/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_UnsavedInputs */

const cs_blog_editor_unsaved = /** @type {(inputs: Blog_Editor_UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuložené změny`)
};

const en_blog_editor_unsaved = /** @type {(inputs: Blog_Editor_UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Blog_Editor_UnsavedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_unsaved = /** @type {((inputs?: Blog_Editor_UnsavedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_UnsavedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_unsaved(inputs)
	return cs_blog_editor_unsaved(inputs)
});